import styled from 'styled-components';

import overlayImage from '../../assets/images/overlay.jpg';

const Background = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background-image: url(${overlayImage});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 50% 50%;
`;

export { Background };
